import React from 'react';
import { IconButton, Box } from '@mui/material';
import { useCurrentEditor } from '@tiptap/react';

const EMAIL_CONTAINER_CLASS = 'email-container';
const EMAIL_CONTAINER_STYLE = 'margin:12px;padding:12px;border:1px solid #ddd;border-radius:5px;';

const ToolbarContainerToggle = () => {
	const { editor } = useCurrentEditor();

	const toggleEmailContainer = () => {
		if (!editor) return;

		const dom = editor.view.dom;
		const existing = dom.querySelector(`.${EMAIL_CONTAINER_CLASS}`);

		if (existing) {
			const childrenHTML = existing.innerHTML;
			editor.commands.setContent(childrenHTML, false);
			return;
		}

		const html = editor.getHTML();
		editor.commands.setContent(
			`<div class="${EMAIL_CONTAINER_CLASS}" style="${EMAIL_CONTAINER_STYLE}">
            ${html}
        </div>`,
			false,
		);
	};

	return (
		<IconButton size='small' onClick={() => toggleEmailContainer(editor)}>
			<Box
				sx={{
					width: 14,
					height: 14,
					border: '1px solid currentColor',
					borderRadius: '4px',
				}}
			/>
		</IconButton>
	);
};

export default ToolbarContainerToggle;
